import React from "react";
import { Trans } from "react-i18next";
import i18n from "../../../../i18n";
import i18next from "i18next";
import { saveAs } from "file-saver";

import {
  Button,
  Callout,
  Dialog,
  HTMLSelect,
  Tag,
  Classes,
} from "@blueprintjs/core";

import {
  getExtension,
  mefDate,
  mefMontant,
  userColors,
  userIcons,
} from "../../../../utils/mef";
import { TableCustom } from "../../../Structure/navbar/blueprintTableincludes";
import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";

const EXPORT_MAX = 100000;

export default class PaymentsHistory extends React.Component {
  constructor() {
    super();
    this.state = { exportFormat: "excel" };
  }

  handleGenerate = () => {
    this.setState({ generating: true });
    authenticatedGetFetch(
      `/financial/payments/history/export?format=${this.state.exportFormat}&` +
        new URLSearchParams(this.props.urlsearchparams),
      (data) => {
        saveAs(
          new Blob([data]),
          "PaymentHistory-" +
            (this.props.urlsearchparams?.fr !== undefined
              ? new Date(this.props.urlsearchparams?.fr).toLocaleString(i18next.language)
              : "") +
            "-" +
            (this.props.urlsearchparams?.to !== undefined
              ? new Date(this.props.urlsearchparams?.to).toLocaleString(i18next.language)
              : new Date().toLocaleString(i18next.language)) +
            `.${getExtension(this.state.exportFormat)}`
        );
        this.setState({ generating: false, progress: 1 });
      },
      undefined,
      undefined,
      () => {
        this.setState({ generating: false });
      },
      true
    );
  };

  render() {
    return this.props.urlsearchparams ? (
      <Callout icon="history" title={<Trans>payment history</Trans>}>
        <TableCustom
          paging={true}
          url={"/financial/payments/history?" + this.props.urlsearchparams}
          orderBy="date"
          columns={[
            {
              title: <Trans>date</Trans>,
              field: "date",
              sortable: true,
              render: (raw) => mefDate(raw.date),
            },
            {
              title: <Trans>park</Trans>,
              field: "park",
              render: (raw) => raw?.device?.park?.name || raw?.device?.park?.id,
            },
            {
              title: <Trans>device</Trans>,
              field: "device",
              render: (raw) => raw?.device?.name || raw?.device?.id,
            },
            {
              title: <Trans>user type</Trans>,
              field: "userType",
              render: (raw) => (
                <Tag
                  icon={userIcons[raw.userType]}
                  style={{ backgroundColor: userColors[raw.userType] }}
                >
                  {i18n.t("userType" + raw.userType)}
                </Tag>
              ),
            },
            {
              title: <Trans>event</Trans>,
              field: "event",
              render: (raw) => i18n.t("event" + raw.event),
            },
            {
              title: <Trans>amount</Trans>,
              field: "amount",
              render: (raw) => mefMontant(raw.amount),
            },
            {
              title: <Trans>mean of payment</Trans>,
              field: "amount",
              render: (raw) => <Trans>{"mop" + raw?.mop?.id}</Trans>,
            },
            {
              title: <Trans>operation id</Trans>,
              field: "amount",
              render: (raw) => raw?.src?.operation_id,
            },
            {
              title: <Trans>mop2</Trans>,
              field: "ccPAN",
              render: (raw) => raw?.src?.ccPAN,
            },
          ]}
        />
        <div>
          <Button
            text={<Trans>export to excel</Trans>}
            onClick={() => this.setState({ isExportOpen: true })}
            icon="th"
          />
          <Dialog
            isOpen={this.state.isExportOpen}
            onClose={() => this.setState({ isExportOpen: false })}
            style={{ transition: "none" }}
            title={<Trans>export to excel</Trans>}
            icon="th"
          >
            <div className={Classes.DIALOG_BODY}>
              <HTMLSelect
                options={[
                  { label: "Excel", value: "excel" },
                  { label: "CSV", value: "csv" },
                  { label: "HTML", value: "html" },
                ]}
                onChange={(s) =>
                  this.setState({ exportFormat: s.target.value })
                }
              />
              {this.state.totalCount > EXPORT_MAX && (
                <Callout
                  intent="warning"
                  title={<Trans>data export will be truncated</Trans>}
                >
                  <Trans>can't export more than</Trans> {EXPORT_MAX}{" "}
                  <Trans>rows</Trans>
                </Callout>
              )}

              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button
                  icon="download"
                  loading={this.state.generating}
                  onClick={this.handleGenerate}
                  text={<Trans>download</Trans>}
                />
              </div>
            </div>
          </Dialog>
        </div>
      </Callout>
    ) : null;
  }
}
